var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "multiselect",
        {
          staticStyle: { float: "left", width: "94%" },
          attrs: {
            id: "groupSelect",
            options: _vm.gateGroupOptions,
            multiple: true,
            taggable: true,
            "tag-placeholder": "ゲートグループの追加",
            "show-labels": false,
            "select-label": "",
            "remove-label": "",
            placeholder: _vm.inputPlaceholder,
            "hide-selected": true,
            "show-no-options": false,
            "max-height": 140,
            disabled: _vm.isDisabled,
            "internal-search": false,
            "clear-on-select": true,
            "close-on-select": false,
            max: _vm.maxSelected,
            label: "name",
            "track-by": "name"
          },
          on: {
            remove: _vm.onRemove,
            open: _vm.updateGateGroup,
            close: _vm.closeDropdown,
            tag: _vm.addTag,
            "search-change": _vm.asyncSearch,
            select: _vm.onSelectGroup
          },
          scopedSlots: _vm._u([
            {
              key: "tag",
              fn: function(props) {
                return [
                  props.option.isNew
                    ? _c(
                        "span",
                        {
                          staticClass: "multiselect__tag",
                          staticStyle: { background: "#007f41" }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(props.option.name))]),
                          _vm._v(" "),
                          props.option.groupId !== undefined
                            ? _c("span", [
                                _vm._v(
                                  "\n              (" +
                                    _vm._s(props.option.groupId) +
                                    ")\n          "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "multiselect__tag-icon",
                            staticStyle: { background: "#007f41" },
                            attrs: { "aria-hidden": "true", tabindex: "1" },
                            on: {
                              click: function($event) {
                                props.remove(props.option)
                              }
                            }
                          })
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticClass: "multiselect__tag",
                          staticStyle: { background: "#468fcc" }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(props.option.name))]),
                          _vm._v(" "),
                          props.option.groupId !== undefined
                            ? _c("span", [
                                _vm._v(
                                  "\n              (" +
                                    _vm._s(props.option.groupId) +
                                    ")\n          "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "multiselect__tag-icon",
                            staticStyle: { background: "#468fcc" },
                            attrs: { "aria-hidden": "true", tabindex: "1" },
                            on: {
                              click: function($event) {
                                props.remove(props.option)
                              }
                            }
                          })
                        ]
                      )
                ]
              }
            },
            {
              key: "option",
              fn: function(props) {
                return [
                  props.option.isTag !== true
                    ? _c("span", [
                        _vm._v(
                          "\n              " +
                            _vm._s(props.option.name) +
                            "\n              "
                        ),
                        props.option.groupId !== undefined
                          ? _c("span", [
                              _vm._v(
                                "\n              (" +
                                  _vm._s(props.option.groupId) +
                                  ")\n          "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [
                    props.option.isTag === true
                      ? _c("span", [_vm._v(_vm._s(props.search))])
                      : _vm._e()
                  ])
                ]
              }
            }
          ]),
          model: {
            value: _vm.gateGroupSelected,
            callback: function($$v) {
              _vm.gateGroupSelected = $$v
            },
            expression: "gateGroupSelected"
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: { color: "red" },
              attrs: { slot: "noResult" },
              slot: "noResult"
            },
            [
              _vm._v(
                "入力されたゲートグループ名は既に使用されています。他のゲートグループ名を入力してください。"
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: { color: "red" },
              attrs: { slot: "maxElements" },
              slot: "maxElements"
            },
            [_vm._v("設定上限を超えております。")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { float: "right", width: "5%" } }, [
        _vm.isDisabled && _vm.isFinishGetDataGroup
          ? _c("i", {
              staticClass: "glyphicon glyphicon-refresh",
              staticStyle: {
                "font-size": "24px",
                color: "#000000",
                "padding-top": "7px",
                "padding-left": "10px",
                float: "left"
              },
              attrs: { id: "group-reload" },
              on: { click: _vm.reloadGateGroup }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f3d347b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f3d347b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/UserGateGroupSelect.vue
// module id = null
// module chunks = 